module.exports = __webpack_public_path__ + "static/media/background_food.4537ec4a.jpg";